module.exports = __webpack_public_path__ + "img/gray.352790bb.svg";